// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"27dd1be9","821":"290cbbc4"}[chunkId] + ".chunk.js";
};